<template>
    <div :class="['ui-padding']">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'ui-padding',
    };
</script>

<style>
    .ui-padding {
        padding: 12px;
    }
</style>



// WEBPACK FOOTER //
// UiPadding.vue?4ef81ebd